var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('user',{class:_vm.$style.user}),_c('router-view',{class:_vm.$style.main,on:{"loading":function($event){return _vm.$emit('loading', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }